import React, { useEffect, useState } from "react";
import config from "../config/config";
import Navbar from "../components/common/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Table } from "react-bootstrap";
import "../styles/HistoryPage.css";

export default function HistoryPage() {
  const [user, setUser] = useState(null);
  const [progress, setProgress] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get user info from token
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded); // Set user state
      } catch (error) {
        console.error("Invalid token:", error);
        setLoading(false);
      }
    } else {
      loadCachedProgress(); // Load cached data if no user
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchUserProgress(user.id); // Fetch progress if user is available
    }
  }, [user]);

  const fetchUserProgress = async (userId) => {
    try {
      const response = await axios.post(
        `${config.API_URL}/api/lesson/user-progress`,
        { userId }
      );
      setProgress(response.data); // Set progress from the backend

      // Do not store anything in localStorage here since we have userId
    } catch (error) {
      console.error("Error fetching user progress:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadCachedProgress = () => {
    // Only load cached data if userId is not available
    if (!user) {
      const cachedData = localStorage.getItem("cachedProgress");
      if (cachedData) {
        setProgress(JSON.parse(cachedData)); // Use cached data
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container-fluid containerDesktop mx-lg-5">
        <div className="mt-4 title">History</div>

        {loading ? (
          <div className="preloader m-5">
            <div className="spinner m-5"></div>
          </div>
        ) : progress.length > 0 ? (
          <Table
            striped
            bordered
            hover
            responsive
            className="mt-5 historyTable"
          >
            <thead>
              <tr>
                <th>Lesson Title</th>
                <th>WPM</th>
                <th>Progress</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {progress.map((item) => (
                <tr key={item.id}>
                  <td className="historyTitle">
                    {item.lesson_title}{" "}
                    {item.individual_lesson_number
                      ? `(Lesson ${item.individual_lesson_number})`
                      : "(Offline)"}
                  </td>
                  <td>{item.sublesson_wpm} WPM</td>
                  <td
                    className={`${
                      item.progress_percentage < 90
                        ? "historyFail"
                        : "historyPass"
                    } historyAccuracy`}
                  >
                    {item.progress_percentage}%
                  </td>
                  <td>
                    {new Date(item.last_updated).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true, // for AM/PM format
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="no-progress-container">
            <p className="no-progress">No progress data available.</p>
          </div>
        )}
      </div>
    </div>
  );
}
